import Id from './Id';
import Status from './Status';
import SourceUser from './SourceUser';
import TargetUser from './TargetUser';
import CreatorUser from './CreatorUser';
import RecordedAt from './RecordedAt';
import Created from './Created';
import Updated from './Updated';

export const labels = {
  Id: 'Id',
  Status: 'Státusz',
  SourceUser: 'Átadó',
  TargetUser: 'Átvevő',
  CreatorUser: 'Létrehozó',
  RecordedAt: 'Rögzítve',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Status',
}, {
  value: 'SourceUser',
}, {
  value: 'TargetUser',
}, {
  value: 'CreatorUser',
}, {
  value: 'RecordedAt',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Status',
}, {
  value: 'SourceUser',
}, {
  value: 'TargetUser',
}, {
  value: 'CreatorUser',
}, {
  value: 'RecordedAt',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'descending'
};

export default {
  Id,
  Status,
  SourceUser,
  TargetUser,
  CreatorUser,
  RecordedAt,
  Created,
  Updated,
};
